import styled from 'styled-components'
import { mobileBreakpoint } from 'react-components'

export const Container = styled.div`
    background-color: ${props => props.theme.colors.white};
    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        margin-bottom: 100px;
    }
`

export const InnerContainer = styled.div`
    max-width: 83rem;
    margin: 0 auto;
`
